import * as pin from "./pin";
import * as cash from "./cash";
import * as giftcard from "./giftcard";

export const nanuri = {
    ...pin,
    ...cash,
    ...giftcard
}
